import { createContext } from 'react';
import type { OMSConfig, OMSOrder } from './types';

export interface OMSContextType {
    configs: Record<string, OMSConfig>;
    orders: OMSOrder[];
    isLoading: boolean;
    updateConfig: (config: OMSConfig) => Promise<void>;
    addOrder: (order: OMSOrder) => Promise<void>;
    updateOrder: (order: OMSOrder) => Promise<void>;
    addOrderLocal: (order: OMSOrder) => void;
    updateOrderLocal: (order: OMSOrder) => void;
    runBacktest: (symbol: string, expiry: string) => Promise<void>;
    refreshData: () => Promise<void>;
}

/**
 * Separated into its own file to prevent Vite HMR from splitting the
 * React Context reference.  When OMSContext lived inside OMSProvider.tsx,
 * hot-reloading that file created a *new* createContext() call, which meant
 * consumers that were NOT re-mounted still held a stale reference and got
 * `null` from useContext.
 */
export const OMSContext = createContext<OMSContextType | null>(null);
